import { Plus } from "lucide-react";
import { FirmPhonesTable } from "@/components/features/settings/firm/FirmPhonesTable";
import { Button, Text } from "@/components/ui";
import { useUser } from "@/components/UserProvider";
import {
  ACTION_PERMISSION_KEYS,
  ACTION_PERMISSION_VALUES,
} from "@/lib/data/static/permissionOptions";
import { useState } from "react";

export default function FirmPhonesCard() {
  const { hasActionPermission } = useUser();
  const [isAddingPhone, setIsAddingPhone] = useState(false);

  const canCreate = hasActionPermission(
    ACTION_PERMISSION_KEYS.firmPhoneNumber,
    ACTION_PERMISSION_VALUES.create,
  );

  return (
    <div className="w-full">
      <div className="mb-8 flex flex-col gap-4 sm:flex-row sm:items-start sm:justify-between">
        <div className="gap-y-1">
          <Text variant="title">Phone numbers</Text>
        </div>
        {canCreate ? (
          <Button
            variant="foreground"
            size="md"
            className="shrink-0"
            onClick={() => {
              setIsAddingPhone(true);
            }}
          >
            <Plus className="h-4 w-4" aria-hidden="true" />
            Add phone number
          </Button>
        ) : null}
      </div>
      <FirmPhonesTable
        isAdding={isAddingPhone}
        setIsAdding={setIsAddingPhone}
      />
    </div>
  );
}
